import { Controller, useFormContext } from 'react-hook-form';
import { useIsFirmRole } from '../../../hooks/use-is-firm-role';
import ChecklistSelect from '../../../components/checklist-select/ChecklistSelect';
import ProcedureTemplateSelect from '../../../components/procedure-template-select/ProcedureTemplateSelect';

type TemplatesSectionProps = {
    isDisabled: boolean;
};

function TemplatesSection({ isDisabled }: TemplatesSectionProps): JSX.Element {
    const { control, formState, trigger } = useFormContext();

    return (
        <div className="flex flex-col gap-2">
            <h3 className="font-medium text-gray-800 text-lg">Templates</h3>
            <div className="flex flex-col gap-8">
                {/* SELECT PROCEDURE TEMPLATE */}
                <Controller
                    name="procedureTemplateId"
                    control={control}
                    render={({ field: { ref, onChange, value } }): JSX.Element => (
                        <ProcedureTemplateSelect
                            isOptional
                            isDisabled={isDisabled}
                            innerRef={ref}
                            onChange={(val): void => {
                                onChange(val);
                                trigger('procedureTemplateId');
                            }}
                            defaultTemplate={value}
                            title="Procedure Template"
                            errorMessage={formState.errors.procedureTemplateId?.message?.toString()}
                        />
                    )}
                />

                {/* SELECT CHECKLIST */}
                <Controller
                    name="checklistId"
                    control={control}
                    render={({ field: { ref, onChange, value } }): JSX.Element => (
                        <ChecklistSelect
                            isOptional
                            isDisabled={isDisabled}
                            innerRef={ref}
                            onChange={(val): void => {
                                onChange(val);
                                trigger('checklistId');
                            }}
                            defaultChecklist={value}
                            title="Checklist"
                            errorMessage={formState.errors.checklistId?.message?.toString()}
                        />
                    )}
                />
            </div>
        </div>
    );
}

export default TemplatesSection;
